<div (click)="select.emit(distance)" class="search-result">{{ location['name'] }} {{ getDistance() }} km</div>